import http from 'utils/http';
import { MetaApiResponse } from '@/utils/types/CommonApiResponse';
import { BusinessUsageAnalytics, BusinessUsageBreakdown, BusinessUsageOverview } from './types';
import { getBusinessUsageAnalyticsUrl, getBusinessUsageBreakdownUrl, getBusinessUsageOverviewUrl } from './apiUrls';

export function getBusinessUsageAnalytics(params?: Record<string, any>): Promise<BusinessUsageAnalytics> {
  return http.get(getBusinessUsageAnalyticsUrl(), params);
}

export function getBusinessUsageBreakdown(
  params?: Record<string, any>
): Promise<{ data: BusinessUsageBreakdown[]; meta: MetaApiResponse }> {
  return http.get(getBusinessUsageBreakdownUrl(), params);
}

export function getBusinessUsageOverview(params?: Record<string, any>): Promise<BusinessUsageOverview> {
  return http.get(getBusinessUsageOverviewUrl(), params);
}
